



























































import OrderProductPrepare from '@/components/order/mixins/OrderProductPrepare';
import PageTitle from '@/components/common/PageTitle.vue';
import OrderContentTop from '@/components/common/order/OrderContentTop.vue';
import ItemTable from '@/components/common/order/ItemTable.vue';
import { Component, Mixins, Ref } from 'vue-property-decorator';
import {OrderStatusType, PutOrderOptionHoldDeliveryRequest} from 'supporter';
import {ncpPopup} from '@/utils/commonUtils';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';
import {CustomGroupFlagCallbackInfo} from '@/components/common/order/mixins/OrderGridsColums';

@Component({
  components: {
    PageTitle,
    OrderContentTop,
    ItemTable
  }
})
export default class OrderListProductPrepare extends Mixins(OrderProductPrepare, OrderGridBrokenFreeGiftMixin) {
  @Ref('gridBottom')
  private readonly gridRef: ItemTable;

  private orderListContent: any = [];
  private totalCount: any = 0;
  private initPageSize: number = 30;
  private delayCount: number = 0;
  private theExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {}
  };
  private request: any = {
    params: {}
  };
  private memberGroup: any[] = [];
  private showMemberGroup: boolean = false;
  private exchangeMemberData: any = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_PRODUCT_PREPARE_MEMBER_GROUP_PUPOP_TITLE',
    nonFooter: false,
    hasConfirmBtn: false
  };
  public ifExchange: boolean = false;
  private exchangeHelpData: any = {
    id: 'exchangeHelp',
    width: 500,
    title: 'ORDER_LIST_GRIDS_PAY_DONE_LAYER_TITLE',
    nonFooter: true
  };
  private searchDateTypeData: any[] = [
    {value: 'STATE_CHANGE_YMDT', name: 'ORDER_PRODUCT_PREPARE_SEARCH_DATA_TYPE_STATE_CHANGE_YMDT'},
    {value: 'ORDER_YMDT', name: 'ORDER_PRODUCT_PREPARE_SEARCH_DATA_TYPE_ORDER_YMDT'}
  ];
  private contentBottomOption: any = {
    haveConfigBtn: true,
    gridName: 'ORDER_PRODUCT_PREPARE_GRID',
    haveExcelDownBtn: true,
    excelDownInfo: {
      columns: {},
      fileName: '',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {}
    }
  };

  private created(): void {}
  private mounted(): void {
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').on('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').on('click', '.detail_pop', $.proxy(this.handleTaskMessageBtn, this));
    $('body').on(
        'click',
        '#exchangeHelpBtn',
        $.proxy(() => {
          this.ifExchange = true;
        }, this)
    );
  }
  private destroyed(): void {
    $('body').off('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').off('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').off('click', '.detail_pop', $.proxy(this.handleTaskMessageBtn, this));
    $('body').off(
      'click',
      '#exchangeHelpBtn',
      $.proxy(() => {
        this.ifExchange = true;
      }, this)
    );
  }

  // LINK: src/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue
  protected changeOrderStatus(items, nextOrderStatus): void {
    this.changeStatusProc(nextOrderStatus, items, false, this.gridRef, 'PRODUCT_PREPARE', this.search);
  }

  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse($(e.target).data('json').replace(/\\\"/g, '"'));
    this.showMemberGroup = true;
  }
  private orderNameClick(e: any): void {
    const memberno = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberno}`, 'ORDER_LIST_GRIDS_ORDER_NAME_POPUP_TITLE', 1100, 980);
  }
  private handleTaskMessageBtn(e: any): void {
    e.preventDefault();
    const orderNo = $(e.target).data('orderNo');
    ncpPopup(`/order/productOptionDetailPopup?orderNo=${orderNo}`, '', 1280, 1162);
  }
  private initRequest(data: any): void {
    this.request.params = data;
  }
  public initExcelColums(): void {
    let columns: any = this.gridProps.columns.map((item: any) => {
      if(item.visible === true) {
        return item.name;
      }
    });
    this.contentBottomOption.excelDownInfo.columns = [];
    columns.forEach((el: any): any => {
      this.contentBottomOption.excelDownInfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.contentBottomOption.excelDownInfo.formatters = this.excelDownInfo.formatters;
    this.contentBottomOption.excelDownInfo.fileName = 'order_product_processing_';
  }

  private handleSearch(e: any, page: number = 1): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
    this.request.params.orderStatusType = 'PRODUCT_PREPARE';
    this.request.params.page = page || 1;
    this.request.params.size = this.size;
    this.request.params.includeHoldDelivery = false;
    $('#loading').show();
    this.$api
      .getOrderOptionsOrderGrid(this.request)
      .then((res) => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'orderDeliveryGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = ['platformType', 'mallNo', 'orderRegisterType', 'reservation', 'memberGroupInfoJson', 'payType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo'];
          let midRow = [
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'shippingNo',
            'deliveryMemo',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'deliveryAmtInAdvanceYn',
            'adjustedAmt',
            'remoteDeliveryAmt',
            'lastSubPayAmt',
            'lastMainPayAmt',
          ];

          let smallRow: any[] = ['partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	        const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'orderNo', 'shippingNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
  }

  private handleCancel(): void {}

  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    this.request.params.orderStatusType = 'PRODUCT_PREPARE';
    this.request.params.page = page;
    this.request.params.size = this.size;
    this.request.params.includeHoldDelivery = false;
    // this.request.params.claimStatusTypes = null;
    $('#loading').show();
    this.$api
      .getOrderOptionsOrderGrid(this.request)
      .then((res) => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'orderDeliveryGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = ['platformType', 'mallNo', 'orderRegisterType', 'reservation', 'memberGroupInfoJson', 'payType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo',
            'lastSubPayAmt',
            'lastMainPayAmt',];
          let midRow = [
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'shippingNo',
            'deliveryMemo',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'deliveryAmtInAdvanceYn',
            'adjustedAmt',
            'remoteDeliveryAmt'
          ];
          let smallRow: any[] = ['partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	        const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'orderNo', 'shippingNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
  }
  private getCheckedItems(arr: any): any {
    return (this.$refs.gridBottom as any).getCheckedItems(arr);
  }

  private changeStatus(type: OrderStatusType): void {
    if (this.getCheckedRowKeys().length === 0) {
      if (type === 'PAY_DONE') {
        alert(this.$t('ORDER_LIST_GRIDS_DEPOSIT_NOT_CHECK_ROW_ALERT'));
      } else {
        alert(this.$t('ORDER_LIST_GRIDS_NOT_CHECK_ROW_ALERT'));
      }
      return;
    }

    if (!confirm(this.$t('ORDER_LIST_GRIDS_CONFIRM_HANDLE_CHANGE') as string)) {
      return;
    }

    const checkList: any = this.getCheckedRows();
    this.changeStatusProc(type, checkList, true, this.$refs.gridBottom, 'PRODUCT_PREPARE', this.search);
  }

  private holdDelivery(orderStatusType: OrderStatusType): void {
    if (this.getCheckedRowKeys().length === 0) {
      alert(this.$t('ORDER_LIST_GRIDS_NOT_CHECK_ROW_ALERT'));
      return;
    }
    const checkedRowList = this.getCheckedRowKeys();

    const flag = checkedRowList.map((row: any): any => this.getRowItems(row).taskMessage).every((value: any) => value === false);
    let message: any;
    if (!flag) {
      message = 'ORDER_LIST_GRIDS_PRODUCT_PREPARE_CHANGE_STATUS_CONFIR_1';
    } else {
      message = 'ORDER_LIST_GRIDS_PRODUCT_PREPARE_CHANGE_STATUS_CONFIRM_2';
    }
    const strs = orderStatusType === 'DELIVERY_PREPARE' ? this.$t('ORDER_LIST_GRIDS_DELIVERY_TAG') : this.$t('ORDER_LIST_GRIDS_OUT_STORE_TAG');
    if (!confirm(this.$t(message, {str: strs}) as string)) {
      return;
    }

    if (orderStatusType == 'DELIVERY_PREPARE') {
      // api 处理
    } else {
      const orderOptionNos = this.getCheckedItems(['orderProductOptionNo']);
      if (!orderOptionNos.length) {
        return;
      }
      let nos: any = orderOptionNos.map((item: any): any => {
        return item.orderProductOptionNo;
      });
      let holdDeliveryRequest: PutOrderOptionHoldDeliveryRequest = {
        params: {
          orderOptionNos: nos.join(',')
        },
        data: {}
      };
      this.$api.putOrderOptionHoldDelivery(holdDeliveryRequest).then((): any => {
        alert(this.$t('ORDER_LIST_GRIDS_HANDLE_DONE'));
        this.search(1, this.size);
      });
    }
  }

  private getRowItems(rowKey: any): any {
    return (this.$refs.gridBottom as any).getRowItems(rowKey);
  }
  private getCheckedRowKeys(): any {
    return (this.$refs.gridBottom as any).getCheckedRowKeys();
  }
  private getCheckedRows(): any {
    return (this.$refs.gridBottom as any).getCheckedRows();
  }
}
